import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { faqDelete } from "../../Redux/Actions/FaqAction";
import { Box, Flex, Text, Button, Stack, Checkbox } from "@chakra-ui/react";
import { Link } from "react-router-dom";

const Faq = (props) => {
    const { faq } = props;
    const dispatch = useDispatch();
    const [showAnswer, setShowAnswer] = useState(false);

    const deleteHandler = (lang, id) => {
        let result = window.confirm("Are you sure?");
        if (result) {
            dispatch(faqDelete(lang, id));
        }
    };

    const removeHtmlTags = (str) => {
        if (!str) return "";
        const text = str.replace(/<[^>]*>/g, "");
        const textArea = document.createElement("textarea");
        textArea.innerHTML = text;
        return textArea.value;
    };

    return (
        <Box
            borderWidth="1px"
            borderRadius="lg"
            overflow="hidden"
            boxShadow="md"
            bg="white"
            p={6}
            maxW="600px"
            m="auto"
            my={4}
        >
            {faq?.faqrecords?.map((record) => {
                const cleanDescription = removeHtmlTags(record.description);
                const truncatedDescription = cleanDescription.substring(0, 50);

                return (
                    <Box key={record.id} mb={6}>
                        {/* Question */}
                        <Text fontSize="xl" fontWeight="bold" color="teal.700" mb={3}>
                            {record.name}
                        </Text>

                        {/* Answer */}
                        <Text>
                            {showAnswer ? cleanDescription : `${truncatedDescription}...`}
                            <Button
                                size="xs"
                                variant="link"
                                colorScheme="teal"
                                onClick={() => setShowAnswer(!showAnswer)}
                            >
                                {showAnswer ? "Show Less" : "Read More"}
                            </Button>
                        </Text>

                        {/* Actions */}
                        <Flex justify="space-between" align="center" mt={2}>
                            <Link to={`/faq/${faq.id}/edit`}>
                                <Button
                                    leftIcon={<i className="fas fa-pen"></i>}
                                    colorScheme="teal"
                                    size="md"
                                    variant="outline"
                                >
                                    Edit
                                </Button>
                            </Link>
                            {/* Status Checkbox */}
                            <Checkbox
                                size="lg"
                                isChecked={faq?.status}
                                mt={3}
                                colorScheme={faq?.status ? "green" : "red"}
                                borderColor={faq?.status ? "green.500" : "red.500"}
                                isReadOnly
                            >
                                <span style={{ color: faq?.status ? 'green' : 'red', fontWeight: 'bold' }}>
                                    {faq?.status ? "Aktivdir" : "Aktiv deyil"}
                                </span>
                            </Checkbox>

                            <Button
                                leftIcon={<i className="fas fa-trash"></i>}
                                colorScheme="red"
                                size="md"
                                variant="outline"
                                onClick={() => deleteHandler(faq.id)}
                            >
                                Delete
                            </Button>
                        </Flex>
                    </Box>
                );
            })}

            {/* If no FAQ records */}
            {faq?.faqrecords?.length === 0 && (
                <Text fontSize="lg" color="gray.500" textAlign="center">
                    No FAQs available.
                </Text>
            )}
        </Box>
    );
};

export default Faq;
